import React from 'react'
import PropTypes from 'prop-types'

import { Table } from 'semantic-ui-react'

import TableHeaderCell from 'Components/TableHeaderCell'

const GroupsTableHeader = props => {
  const { handleSort, sortBy, sortOrder } = props

  return (
    <Table.Header>
      <Table.Row>
        <TableHeaderCell handleSort={handleSort} icon="tag" id="name" sortOrder={sortOrder} sorting={sortBy === 'name'} text="Name" />

        <TableHeaderCell handleSort={handleSort} icon="hashtag" id="id" sortOrder={sortOrder} sorting={sortBy === 'id'} text="ID" />

        <TableHeaderCell
          handleSort={handleSort}
          icon="lock"
          id="permissions"
          sortOrder={sortOrder}
          sorting={sortBy === 'permissions'}
          text="Number of Permissions"
        />

        <TableHeaderCell
          handleSort={handleSort}
          icon="users"
          id="users"
          sortOrder={sortOrder}
          sorting={sortBy === 'users'}
          text="Number of Users"
        />
      </Table.Row>
    </Table.Header>
  )
}

GroupsTableHeader.propTypes = {
  handleSort: PropTypes.func,
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
}

export default GroupsTableHeader
